import { __decorate } from "tslib";
// Core
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
// Extends
// Children
// Models / Helpers
// Queries / Mutations
let SwitchTransition = class SwitchTransition extends Vue {
};
__decorate([
    Prop({ type: String, default: 'out-in' })
], SwitchTransition.prototype, "mode", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], SwitchTransition.prototype, "multiRender", void 0);
SwitchTransition = __decorate([
    Component
], SwitchTransition);
export default SwitchTransition;
